<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Use the font name you defined in your @font-face rule
const newFont = "'Gotham Bold', sans-serif";

// Select the root element (<html>) where the CSS variables are defined
const rootElement = document.documentElement;

// Set the new font family for the two CSS variables
rootElement.style.setProperty('--font-family-2', newFont);
rootElement.style.setProperty('--font-heading-family', newFont);
rootElement.style.setProperty('--blog-title-font', newFont);
rootElement.style.setProperty('--font-tab-type-2', newFont);